(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-oxy-data]').textContent);
    const gallery = root.querySelector('[data-oxy-gallery]');
    const slides = [...root.querySelectorAll('[data-oxy-slide]')];
    const thumbs = [...root.querySelectorAll('[data-oxy-image]')];
    const form = root.querySelector('form');
    const quantity = form.elements.quantity;
    const add = root.querySelector('[data-oxy-atc]');
    const errorBox = root.querySelector('[data-oxy-error]');
    const sticky = root.querySelector('[data-oxy-sticky]');
    const addons = [...root.querySelectorAll('[data-oxy-addon]')].map(card => ({
      card,
      check: card.querySelector('[data-oxy-addon-check]'),
      select: card.querySelector('[data-oxy-addon-variant]')
    }));
    const addonFieldset = root.querySelector('[data-oxy-addons]');
    const selectionTotal = root.querySelector('[data-oxy-selection-total]');
    const totalValue = root.querySelector('[data-oxy-total-value]');
    const money = new Intl.NumberFormat(data.locale || document.documentElement.lang || 'en-GB', {
      style: 'currency', currency: data.currency || 'GBP'
    });
    const selectedAddons = () => {
      const selected = new Map();
      const baseId = Number(form.elements.id.value);
      addons.forEach(({check, select}) => {
        const option = select.selectedOptions[0];
        const id = Number(option?.value);
        if (!check.checked || check.disabled || select.disabled || !option || option.disabled || !Number.isSafeInteger(id) || id <= 0 || id === baseId) return;
        const price = Number(option.dataset.price);
        if (Number.isFinite(price) && price >= 0) selected.set(id, {id, price});
      });
      return [...selected.values()];
    };
    const updateTotal = () => {
      if (!selectionTotal || !totalValue) return;
      const selected = selectedAddons();
      selectionTotal.hidden = selected.length === 0;
      const total = (Number(quantity.value) || 1) * Number(data.basePrice || 0) + selected.reduce((sum, addon) => sum + addon.price, 0);
      totalValue.textContent = money.format(total / 100);
    };
    const updateAddon = ({card, select}) => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const price = card.querySelector('[data-oxy-addon-price]');
      const image = card.querySelector('[data-oxy-addon-image]');
      const link = card.querySelector('[data-oxy-addon-link]');
      if (price) price.textContent = option.dataset.priceText || money.format(Number(option.dataset.price) / 100);
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = option.dataset.image;
      }
      if (link) {
        const url = new URL(link.href, window.location.href);
        url.searchParams.set('variant', option.value);
        link.href = url.href;
      }
    };
    addons.forEach(addon => {
      updateAddon(addon);
      addon.check.addEventListener('change', updateTotal);
      addon.select.addEventListener('change', () => {updateAddon(addon);updateTotal();});
    });
    if (addonFieldset && addons.length) addonFieldset.hidden = false;
    quantity.addEventListener('input', updateTotal);
    quantity.addEventListener('change', updateTotal);
    updateTotal();
    const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const go = index => gallery.scrollTo({left:gallery.clientWidth * index, behavior:reduced() ? 'auto' : 'smooth'});
    thumbs.forEach((button,index) => button.addEventListener('click', () => go(index)));
    gallery.addEventListener('keydown', event => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const current = Math.round(gallery.scrollLeft / gallery.clientWidth);
      go(Math.max(0, Math.min(slides.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1))));
    });
    const galleryObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const index = slides.indexOf(entry.target);
      thumbs.forEach((button,i) => button.setAttribute('aria-pressed', String(i === index)));
    }), {root:gallery,threshold:0.7});
    slides.forEach(slide => galleryObserver.observe(slide));
    const adjust = delta => {
      const maximum = quantity.max ? Number(quantity.max) : Number.MAX_SAFE_INTEGER;
      quantity.value = String(Math.max(1, Math.min(maximum, (Number(quantity.value) || 1) + delta)));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    };
    root.querySelector('[data-oxy-minus]').addEventListener('click', () => adjust(-1));
    root.querySelector('[data-oxy-plus]').addEventListener('click', () => adjust(1));
    let busy = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      const items = [{id:Number(form.elements.id.value),quantity:Number(quantity.value)}, ...selectedAddons().map(({id}) => ({id,quantity:1}))];
      const controls = [add, quantity, root.querySelector('[data-oxy-minus]'), root.querySelector('[data-oxy-plus]'), ...addons.flatMap(({check,select}) => [check,select])];
      const disabledStates = controls.map(control => [control, control.disabled]);
      busy = true;
      controls.forEach(control => {control.disabled = true;});
      add.textContent = data.adding;
      errorBox.hidden = true;
      try {
        if (typeof window.twCartAddItems !== 'function') throw new Error(data.error);
        await window.twCartAddItems(items);
      } catch (error) {
        errorBox.textContent = error.message || data.error;
        errorBox.hidden = false;
      } finally {
        busy = false;
        disabledStates.forEach(([control,disabled]) => {control.disabled = disabled;});
        add.textContent = data.add + ' →';
        updateTotal();
      }
    });
    const stickyObserver = new IntersectionObserver(() => {sticky.hidden = add.getBoundingClientRect().bottom > 0;}, {threshold:[0,1]});
    stickyObserver.observe(add);
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {galleryObserver.disconnect();stickyObserver.disconnect();}, {once:true});
  }
  document.querySelectorAll('[data-oxy-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-oxy-root]').forEach(init));
})();

